import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logout } from "~/api";
import { ROUTES } from "~/router";
import { clearSessionData } from "~/shared/utils/logout";
import { errorToast } from "~/ui/admin";

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearSessionData();

      queryClient.setQueryData(["verifySession"], null);

      queryClient.removeQueries({
        queryKey: ["currentUser"],
      });

      window.location.href = ROUTES.fullLogin;
    },
    onError: errorToast,
  });
};
